import type { Theme } from '@mui/material';

export const styles = {
  responseRateWidget: () => ({
    overflow: 'auto',
    flexGrow: 1,
  }),

  blockWrap: (theme: Theme) => ({
    width: 'auto',
    display: 'flex',
    alignItems: 'center',

    // Override media query styles by specificity.
    '&.MuiGrid-root, .MuiGrid-root': {
      [theme.breakpoints.up('md')]: {
        flexBasis: 'auto',
        flexGrow: 0,
      },
    },
  }),

  responseBackground: {
    marginRight: 1,
    height: '2.125rem',
    position: 'relative',
  },

  responseFiller: {
    position: 'absolute',
    top: 0,
    left: 0,
    overflow: 'hidden',
  },
};
